<template>
  <div>
    <v-card outlined class="pa-4 pa-sm-8" max-width="650">
      <v-alert color="primary" text class="pl-8 mb-8">
        <ressource code="informations_infos_repondants" />
      </v-alert>
      <v-row>
        <v-col cols="12" md="2">
          <v-icon x-large>mdi-account-tie</v-icon>
        </v-col>
        <v-col cols="12" md="10">
          <CarteIdentificationLigne code="repondant" :value="societe.repondantFullName" />
          <CarteIdentificationLigne code="repondant_substitut" :value="societe.repondantSubstitutFullName" />
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import CarteIdentificationLigne from "./CarteIdentificationLigne.vue"
export default {
  components: { CarteIdentificationLigne },
  props: {
    societe: Object
  }
}
</script>